export default __webpack_public_path__ + "static/media/lunch4.bc2a5b5c.png";